var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.2754V24.6504M22.5 41.5254C13.4438 41.5254 6.09375 34.1754 6.09375 25.1191C6.09375 16.0629 13.4438 8.71289 22.5 8.71289C31.5562 8.71289 38.9062 16.0629 38.9062 25.1191",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.02539H28.125M27.9375 34.9629V32.7879C27.9375 30.1066 29.85 29.0004 32.175 30.3504L34.05 31.4379L35.925 32.5254C38.25 33.8754 38.25 36.0691 35.925 37.4191L34.05 38.5066L32.175 39.5941C29.85 40.9441 27.9375 39.8379 27.9375 37.1566V34.9629Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.8c73ddf9271aba1e79e3055c0731e8d0.svg";
export { ForwardRef as ReactComponent };